import { render, staticRenderFns } from "./Appointment.vue?vue&type=template&id=42cc9b5a&scoped=true&"
import script from "./Appointment.vue?vue&type=script&lang=js&"
export * from "./Appointment.vue?vue&type=script&lang=js&"
import style0 from "./Appointment.vue?vue&type=style&index=0&id=42cc9b5a&prod&lang=scss&scoped=true&"
import style1 from "./Appointment.vue?vue&type=style&index=1&id=42cc9b5a&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42cc9b5a",
  null
  
)

export default component.exports